import clsx from 'clsx';
import React, { Children, cloneElement, forwardRef, useCallback, useEffect, useState } from 'react';
import * as RDropdownMenu from '@radix-ui/react-dropdown-menu';
import { AnimatePresence, motion } from 'framer-motion';
import { dropdown as dropdownClass, titleContainer as titleContainerClass, separatorContainer as separatorContainerClass, } from './dropdown.module.css';
import { Separator } from '../separator';
import { ClampText } from '../clamp-text';
export const Dropdown = forwardRef(({ className, activator, title, dimension = 'mini', onOpenChange, children, open = false, ...props }, forwardedRef) => {
    const [visible, setVisible] = useState(false);
    const filteredChildren = Children.toArray(children).filter(Boolean);
    useEffect(() => {
        if (open !== visible) {
            setVisible(open);
        }
    }, [open]);
    const handleOpen = useCallback(() => (openStatus) => {
        setVisible(openStatus);
        if (onOpenChange)
            onOpenChange(openStatus);
    }, [onOpenChange]);
    return (React.createElement(AnimatePresence, null,
        React.createElement(RDropdownMenu.Root, { onOpenChange: handleOpen(), open: visible },
            React.createElement(RDropdownMenu.Trigger, { asChild: true }, activator),
            React.createElement(RDropdownMenu.Content, { asChild: true },
                React.createElement("div", { ref: forwardedRef, className: clsx(dropdownClass, className), "data-title": Boolean(title), "data-dimension": dimension, ...props },
                    React.createElement(motion.div, { animate: visible ? { y: 8, opacity: 1 } : { y: 0, opacity: 0 }, transition: { ease: 'easeOut', duration: 0.1 } },
                        title ? (React.createElement("div", { className: titleContainerClass },
                            React.createElement(ClampText, { rows: 1 }, title),
                            React.createElement(RDropdownMenu.Separator, { asChild: true },
                                React.createElement("div", { className: separatorContainerClass },
                                    React.createElement(Separator, null))))) : null,
                        Children.map(filteredChildren, (child) => cloneElement(child))))))));
});
